// Admin Notifications tab (cross-backend → admin-corev2). Same method signatures
// as pitstop-ui's native settingApi so the ported admin notification component
// reads identically; only the backend differs (admin headers via adminRequest).
import { adminRequest } from './client.js';

export const adminSettingApi = {
	getNotifications: async (options = {}) => {
		const { setLoading, addToastMessage } = options;
		if (setLoading) setLoading(true);
		const [error, data] = await adminRequest('GET', '/settings/user-notifications');
		if (error && !error.sessionExpired && addToastMessage) {
			addToastMessage('Failed to get notification settings', 'error');
		}
		if (setLoading) setLoading(false);
		return [error, data];
	},

	updateNotifications: async (payload, options = {}) => {
		const { setLoading, addToastMessage } = options;
		if (setLoading) setLoading(true);
		const [error, data] = await adminRequest('PUT', '/settings/user-notifications', payload);
		if (error && !error.sessionExpired && addToastMessage) {
			addToastMessage('Failed to update notification settings', 'error');
		}
		if (setLoading) setLoading(false);
		return [error, data];
	},

	// Proactive refresh of the admin token when the tab opens (the admin token ages
	// while pitstop is the active surface). Best-effort; 401 = already expired.
	renewToken: async () => {
		const [error, data] = await adminRequest('POST', '/renew-token');
		const token = data?.token;
		if (!error && token) sessionStorage.setItem('adminCoreToken', token);
		return [error, data];
	},
};
